//Any non-senstive storeconf variable should be added here to access it from settings.userData
//Do not add sensitive variables to this list
//Keep the list in Alphabatical order for readability
export const USERDATA_GENERIC_STORECONF_KEYS = [
    'APlusLegoVendor',
    'AllowStorePickForOOSItems',
    'bvSiteId',
    'bvEnvironment',
    'bvLocale',
    'bvClientName',
    'ClickAndCollectStoreEndTimeCutOff',
    'ClickAndCollectShowStoresCount',
    'google.tag.manager.container.id',
    'google.tag.manager.auth',
    'google.tag.manager.preview',
    'google.analytics.versions',
    'GiftCardsToExcludeAfterThreshold',
    'GroupOtherPaymentTypes',
    'GTMEnvironment',
    'HideProductAttributes',
    'headlessStore.storeContextRoot',
    'isWebpON',
    'Klarna_Environment',
    'Klarna_ExpressButtonEndPointURL',
    'Klarna_OnsiteMessagingEndPointURL',   
    'Locationiq_Service_URL',
    'Locationiq_results_limit',
    'Locationiq_viewbox_coordinates',
    'maxImagesRuby',
    'MyAccountAllowedUserAge',
    'WebPImageOptimizedFolder',
    'orderActualFreeShippingMinimum',
    'orderActualCheckoutMinimum',
    'orderFreeShippingMinimum',
    'orderCheckoutMinimum',
    'RibbonsDisplayCount',
    'RobotsExcludeFollowPages',
    'RobotsExcludeNoFollowPages',
    'RobotsExcludeFollowPages1',
    'StoreStockStoreCountTODisplay',
    'StoreLocatorStoreStockPDP_MaxItems',
    'StorepickAllowedAttributeValue',
    'StorepickAllowedAttribute',
    'StoreLocator_RadiusUOM',
    'StoreLocator_Radius',
    'StorePickupMaxAllowedQuantity',
    'StaticHostSecure',
    'SiteLink_DomainName',
    'PaazlShippingEnabled',
    'VVV_GIFT_CARD_THRESHOLD',
    'StoreLocatorSpecialOpeningMaxCount',
    'HomePageTokenValue',
]